import React, { useState } from "react";
import "./people.css";

const SocialResponsibility = () => {
  const [quizAnswer, setQuizAnswer] = useState("");
  const [quizResult, setQuizResult] = useState(null);
  const [gameResult, setGameResult] = useState(null);

  // Handle quiz submission
  const handleQuizSubmit = () => {
    if (quizAnswer.trim().toLowerCase() === "trees") {
      setQuizResult("✅ Correct! Trees absorb carbon dioxide and improve air quality.");
    } else {
      setQuizResult("❌ Oops! The correct answer is 'Trees'.");
    }
  };

  // Handle game choices
  const handleGameChoice = (choice) => {
    if (choice === "good") {
      setGameResult("🌱 Great choice! That helps reduce air pollution.");
    } else {
      setGameResult("🚫 Not the best option! Try making eco-friendly choices.");
    }
  };

  return (
    <div className="social-responsibility-section p-6 mt-6 bg-green-50 rounded-lg shadow-md">
      <h2 className="text-xl font-semibold mb-4">Make a Difference!</h2>
      <p className="text-gray-700 mb-4">
        Air quality is something we can all impact. Join efforts to make our world cleaner and healthier by supporting initiatives like tree planting, reducing emissions, and promoting eco-friendly activities.
      </p>

      {/* Interactive Quiz */}
      <div className="quiz-section bg-white p-4 rounded-lg shadow-sm mb-6">
        <h3 className="font-semibold text-lg">Quick Quiz: What absorbs CO₂ and improves air quality?</h3>
        <input
          type="text"
          placeholder="Your answer..."
          className="border p-2 rounded w-full mt-2"
          value={quizAnswer}
          onChange={(e) => {
            setQuizAnswer(e.target.value);
            setQuizResult(null);
          }}
        />
        <button
          className="bg-blue-500 text-white px-4 py-2 mt-2 rounded hover:bg-blue-600 transition-all"
          onClick={handleQuizSubmit}
        >
          Submit Answer
        </button>
        {quizResult && <p className="mt-2 font-semibold text-gray-700">{quizResult}</p>}
      </div>

      {/* Air Quality Awareness Game */}
      <div className="game-section bg-white p-4 rounded-lg shadow-sm mb-6">
        <h3 className="font-semibold text-lg">Mini Game: Eco-Friendly Choices</h3>
        <p className="text-gray-600 mb-2">Click the best option to reduce air pollution:</p>
        <div className="flex flex-wrap gap-2">
          <button
            className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600 transition-all"
            onClick={() => handleGameChoice("good")}
          >
            Use Public Transport
          </button>
          <button
            className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600 transition-all"
            onClick={() => handleGameChoice("bad")}
          >
            Drive Alone in a Car
          </button>
          <button
            className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600 transition-all"
            onClick={() => handleGameChoice("good")}
          >
            Plant More Trees
          </button>
          <button
            className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600 transition-all"
            onClick={() => handleGameChoice("bad")}
          >
            Burn Waste
          </button>
        </div>
        {gameResult && <p className="mt-2 font-semibold text-gray-700">{gameResult}</p>}
      </div>

      {/* Programs and Actions */}
      <div className="programs-list space-y-4">
        <div className="program-item bg-white p-4 rounded-lg shadow-sm">
          <h3 className="font-semibold text-lg">Tree Planting Programs</h3>
          <p className="text-gray-600">
            Plant trees to help reduce air pollution and improve our ecosystem. Join local and global programs now.
          </p>
          <a
            href="https://www.treeplantingprogram.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-500 hover:underline"
            aria-label="Learn more about tree planting programs"
          >
            Learn More and Join
          </a>
        </div>

        <div className="program-item bg-white p-4 rounded-lg shadow-sm">
          <h3 className="font-semibold text-lg">Carbon Offset Initiatives</h3>
          <p className="text-gray-600">
            Offset your carbon footprint by supporting environmental protection programs. Every bit helps!
          </p>
          <a
            href="https://www.carbonoffset.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-500 hover:underline"
            aria-label="Offset your carbon footprint"
          >
            Offset Your Carbon Footprint
          </a>
        </div>
      </div>

      {/* Action Links */}
      <div className="actions mt-6">
        <h4 className="font-semibold text-lg mb-2">Take Action:</h4>
        <ul className="list-inside list-disc text-gray-700">
          <li>
            <a href="#" className="text-blue-500 hover:underline">
              Sign up for tree planting events
            </a>
          </li>
          <li>
            <a href="#" className="text-blue-500 hover:underline">
              Donate to offset your carbon footprint
            </a>
          </li>
          <li>
            <a href="#" className="text-blue-500 hover:underline">
              Share on Social Media
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default SocialResponsibility;
